module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty21.ca06aa02.jpg";